import React from 'react';
import { Button, IconButton } from 'rsuite';
import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';
import FileDownloadIcon from '@rsuite/icons/FileDownload';

const ExportExcel = ({ excelData, fileName, name }) => {
    
    const fileType = 'application/vnd.openxml formats-officedocument. spreadsheetml. sheet; charset-UTF-8';
    const fileExtension = '.xlsx';

    const exportToExcel = async() => {
        console.log(excelData)
        const ws = XLSX.utils.json_to_sheet(excelData);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data']};
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array'});
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
    }

    return(
        <>
                <IconButton appearance="primary" color="green" icon={<FileDownloadIcon />} onClick={(e)=> exportToExcel(fileName)}>
                {name!== undefined ? name : 'Download Excel'}
                            </IconButton>
        </>
    )

}

export default ExportExcel;